import {registerImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/register-image-op-node"
import {ImageOpInputsOrNodes} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {definition} from "@app/textures/texture-editor/operator-stack/operators/tiling/node/penalize-by-distance/definition"
import {ImageOpTilingPenalizeByDistanceHal} from "@app/textures/texture-editor/operator-stack/operators/tiling/node/penalize-by-distance/hal"
import {BasicSpecializingImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/basic-specializing-image-op-node"

const nodeDefinition = {...definition, nodeClass: "ImageOpNodeTilingPenalizeByDistance"}

@registerImageOpNode
export class ImageOpNodeTilingPenalizeByDistance extends BasicSpecializingImageOpNode<typeof definition, ImageOpTilingPenalizeByDistanceHal> {
    override get definition() {
        return nodeDefinition
    }

    constructor(parameters: ImageOpInputsOrNodes<typeof definition>) {
        super(ImageOpTilingPenalizeByDistanceHal, parameters)
    }
}
